import React, { ReactElement, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../hooks/auth';

function InitialPage(): ReactElement {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      if (user.transportadora) {
        navigate('/portal');
      } else {
        navigate('/admin');
      }
    } else {
      navigate('/login');
    }
  });

  return <></>;
}

export default InitialPage;
